import React, { useState, useEffect } from "react";
import { MainAdminNewsCategoryTable, UploadNewsSideInput } from "../../components"
import { Outlet } from "react-router-dom"
import Text from "../../assets/icon/NewsIcons/MainAdmin/NewsText"
import Group from "../../assets/icon/NewsIcons/MainAdmin/NewsGroup"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { axiosReq } from "../../commons/axiosReq";
import { useLocation } from "react-router-dom";
import parse from 'html-react-parser';
import Cookies from 'universal-cookie';

const MainAdminEditNews = () => {
    const [data, setData] = useState();
    const [cats, setCats] = useState([]);
    const [text, setText] = useState();
    const [accept, setAccept] = useState();
    const location = useLocation();
    const [tags, setTags] = useState();
    const [searchTag, setSearchTag] = useState("");
    const [reCheck, setRecheck] = useState();
    const [video, setVideo] = useState();
        const [image, setImage] = useState([]);
    
    const GetData = async () => {
        console.log(location?.state)

        if (location?.state?.id) {
            setAccept(location?.state?.accept)
            const articleData = await axiosReq("Admins/GetArticlebySlug?slug=" + location?.state?.id, "get");
            console.log(articleData)
            setData(articleData)
            let newsText = articleData?.newsText;
            const videoRegex = /<video[\s\S]*?<\/video>/g;
            const match = videoRegex.exec(newsText);

            if (match) {
                const target = match.index;
                const videoTag = match[0];
                console.log('Video tag found:', videoTag);
    
                const firstPart = newsText.substring(0, target);
                const secondPart = newsText.substring(target + videoTag.length, newsText.length);

                // Assuming `video` is the new video tag you want to insert
                const newVideoTag = '<p>video</p>';
                newsText = firstPart + newVideoTag + secondPart;
                setVideo(videoTag)
                setText(newsText);
            setText(newsText)
            }
            else{
                setText(articleData?.newsText)
            }
          
            

        }

    const cookies = new Cookies();

        const catsData = await axiosReq(cookies.get('role')=="Admin"?"Admins/GetCategories":"Admins/GetCategoryByAuthorId", "get");
            console.log(catsData)

        var catArr = [];
        catsData?.data?.map((item) => {
            catArr.push({ value: item.categoryId, label: item.categoryName })
        })
        setCats(catArr)

        console.log({ data })
    }
    useEffect(() => {

        GetData();
    }, []);
    const GetTags = async () => {
        const tagsData = await axiosReq("Admins/GetTags?search=" + searchTag, "get");
        console.log(1234)
        console.log(tagsData)

        var tagArr = [];
        tagsData?.data?.map((item) => {
            tagArr.push({ value: item.tagId, label: item.tag })
        })
        setTags(tagArr)
    }
    useEffect(() => {
        GetTags();
    }, [reCheck, searchTag]);
    //     useEffect(() => {
    // alert(text)
    //     }, [text]);


    return (
        <div>
            <div className="flex items-center border-b-2 border-borderGray p-[20px]">
                <div className="flex items-center">
                    <div><Text /></div>
                    <p className="font-IRANYekanExtra text-mainColor2 text-[15px] mr-[15px]">ویرایش خبر</p>
                </div>
            </div>
            {data?.articleStatusId == 3 ?
                <div className="pt-[20px] px-[20px] w-full">
                    <div className="h-fit py-2 px-[15px] w-full border-2 rounded-[15px] bg-[#f8eae9] border-[#ea5c52]">
                        <p className="text-[15px] font-IRANYekanExtra text-[#ea4338] mb-3">علت رد خبر</p>
                        <p className="text-[13px] font-IRANYekanMedium mb-4 text-justify leading-6">{data?.rejectDescription}</p>
                    </div>
                </div>
                :
                null
            }
            <div className="pt-[20px] px-[20px] pb-[280px] w-full flex">
                <div className="w-[29%] ml-[1%]">
                    {
                        data ?
                            <UploadNewsSideInput edit={true} data={data} cats={cats} text={text}accept={accept} image={image}
                            tags={tags} reCheck={reCheck} setRecheck={setRecheck} setSearchTag={setSearchTag} video={video} setVideo={setVideo}
                            />
                            :
                            null
                    }
                </div>
                <div className="w-[70%]">
                    {
                        data ?
                            <Outlet context={[setText, text, accept, data,video,setVideo,image,setImage]} />
                            :
                            null
                    }
                </div>
            </div>
        </div>
    )
}

export default MainAdminEditNews;